var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "b-dropdown",
        {
          staticClass: "apply-inline-button",
          attrs: {
            "toggle-class": _vm.dropdownToggleClass,
            variant: _vm.variant
          }
        },
        [
          _c(
            "template",
            { slot: "button-content" },
            [
              _vm.noItemDefined
                ? _c("ItpText", {
                    attrs: { text: _vm.messages.noTemplateDefind }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.noItemDefined && !_vm.selectedItem
                ? _c("ItpText", {
                    attrs: { text: _vm.messages.selectTemplate }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedItem
                ? _c(
                    "DIV",
                    [
                      _c(
                        "ItpText",
                        {
                          attrs: {
                            muted: _vm.selectedItem.inactive,
                            strikethrough: _vm.selectedItem.inactive
                          }
                        },
                        [
                          _c("span", { staticClass: "pr-1" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.selectedItem.name) +
                                " (" +
                                _vm._s(_vm.selectedItem.template_type) +
                                ")\n        "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.items, function(item) {
            return _c(
              "b-dropdown-item-button",
              {
                key: item.id,
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.evh_5962862420439144_clickPrevent($event, {
                      item: item
                    })
                  }
                }
              },
              [
                _c(
                  "ItpText",
                  {
                    attrs: {
                      muted: item.inactive,
                      strikethrough: item.inactive
                    }
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        "\n        " +
                          _vm._s(item.name) +
                          " (" +
                          _vm._s(item.template_type) +
                          ")\n      "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          !_vm.noItemDefined ? _c("b-dropdown-divider") : _vm._e(),
          _vm._v(" "),
          _c("ItpNavItem", {
            attrs: {
              href: "#",
              "dropdown-item": "",
              icon: "fa-plus",
              text: _vm.messages.createTemplate
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.evh_1048678296148443_clickPrevent($event, {})
              }
            }
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }